import { Axios } from "../api/axios";
import { useInfoStore } from "../store/userInfo";
import { logger } from "../utils/logger";

export const userLogin = (userid: string, password: string) => {
  try {
  return Axios(
    { 
      method: 'post',
      url: '/auth/login/table-users',
      data: {
        userid,
        password
      }
    }).then(response => {
      if (response.data.accessToken) {
        localStorage.setItem("s_u", JSON.stringify(response.data));
        const {refreshToken, accessToken} = response.data
        localStorage.setItem("s_u_t", JSON.stringify({refreshToken,accessToken}));
      }

      return response.data;
    });
  }catch(error) {
    logger.error(error)
  }
};

export const quickLogin = (userid: string) => {
  return Axios(
    { 
      method: 'post',
      url: '/auth/quick-login/table-users',
      data: {
        userid
      }
    }).then(response => {
      if (response.data.accessToken) {
        localStorage.setItem("s_u", JSON.stringify(response.data));
        const {refreshToken, accessToken} = response.data
        localStorage.setItem("s_u_t", JSON.stringify({refreshToken,accessToken}));
      }

      return response.data;
    });
};

export const QRlogin = (data: string) => {

  return Axios(
    { 
      method: 'post',
      url: '/auth/login-qr/table-users',
      data: {data: data}
    }).then(response => {
      if (response.data.accessToken) {
        localStorage.setItem("s_u", JSON.stringify(response.data));
        const { accessToken} = response.data
        localStorage.setItem("s_u_t", JSON.stringify({accessToken}));
      }

      return response.data;
    });
};

export const callLogOut = () => {
    const {logout} = useInfoStore.getState();;
    localStorage.removeItem("s_u");
    localStorage.removeItem("user");
    logout()
    window.location.href = "/";
};


export const getCurrentUser = () => {
  const userStr = localStorage.getItem("s_u");
  if (userStr) return JSON.parse(userStr);

  return null;
};

